export default (percentage: number) => {
  return -percentage * (percentage - 2);
};
